/**
 * SORA PDP swipe gallery — packshot → in-home lifestyle.
 * Touch + mouse drag, arrows, dots, thumbs, keyboard. Safe beside tour JS.
 */
(function () {
  var root = document.querySelector("[data-pdp-carousel]");
  if (!root) return;

  var viewport = root.querySelector("[data-pdp-viewport]");
  var track = root.querySelector("[data-pdp-track]");
  var slides = Array.prototype.slice.call(root.querySelectorAll("[data-pdp-slide]"));
  var dots = Array.prototype.slice.call(root.querySelectorAll("[data-pdp-dot]"));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-pdp-thumb]"));
  var prevBtn = root.querySelector("[data-pdp-prev]");
  var nextBtn = root.querySelector("[data-pdp-next]");
  var cue = root.querySelector("[data-pdp-cue]");
  if (!viewport || !track || slides.length === 0) return;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var index = 0;
  var pointerId = null;
  var startX = 0;
  var startY = 0;
  var deltaX = 0;
  var dragging = false;
  var lockedAxis = null;
  var interacted = false;

  function clamp(i) {
    return Math.max(0, Math.min(slides.length - 1, i));
  }

  function width() {
    return viewport.clientWidth || 1;
  }

  function setTransform(offsetPx, animate) {
    if (animate && !reduceMotion) {
      track.style.transition = "transform 0.42s cubic-bezier(0.22, 1, 0.36, 1)";
    } else if (animate && reduceMotion) {
      track.style.transition = "none";
    } else {
      track.style.transition = "none";
    }
    track.style.transform = "translate3d(" + offsetPx + "px,0,0)";
  }

  function goTo(next, animate) {
    index = clamp(next);
    slides.forEach(function (slide, i) {
      var on = i === index;
      slide.classList.toggle("is-active", on);
      slide.setAttribute("aria-hidden", on ? "false" : "true");
    });
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle("is-active", on);
      dot.setAttribute("aria-current", on ? "true" : "false");
    });
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle("is-active", i === index);
    });
    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    /* data-index kept for analytics / legacy hooks. Viewport size is fixed 1:1
       for all slides (pdp-mobile-gallery-proportion-20260801) — no stage resize. */
    root.setAttribute("data-index", String(index));
    root.classList.toggle("is-lifestyle-stage", index > 0);
    setTransform(-index * width(), animate !== false);
  }

  function markInteracted() {
    if (interacted) return;
    interacted = true;
    root.classList.add("is-interacted");
    if (cue) cue.setAttribute("hidden", "");
  }

  function onResize() {
    goTo(index, false);
  }

  function endDrag() {
    if (!dragging) return;
    dragging = false;
    lockedAxis = null;
    track.classList.remove("is-dragging");
    try {
      if (pointerId != null) viewport.releasePointerCapture(pointerId);
    } catch (e) {}
    pointerId = null;
    var threshold = width() * 0.18;
    if (deltaX <= -threshold) goTo(index + 1, true);
    else if (deltaX >= threshold) goTo(index - 1, true);
    else goTo(index, true);
    deltaX = 0;
  }

  viewport.addEventListener("pointerdown", function (event) {
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (slides.length < 2) return;
    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    deltaX = 0;
    dragging = true;
    lockedAxis = null;
    track.classList.add("is-dragging");
    setTransform(-index * width(), false);
    /* Do NOT setPointerCapture here — capturing on pointerdown traps vertical
       finger-scroll on mobile. Capture only after the gesture locks to X. */
  });

  viewport.addEventListener("pointermove", function (event) {
    if (!dragging || event.pointerId !== pointerId) return;
    var dx = event.clientX - startX;
    var dy = event.clientY - startY;
    if (!lockedAxis) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      lockedAxis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if (lockedAxis === "y") {
        dragging = false;
        track.classList.remove("is-dragging");
        goTo(index, false);
        return;
      }
      try {
        viewport.setPointerCapture(pointerId);
      } catch (e) {}
    }
    if (lockedAxis !== "x") return;
    event.preventDefault();
    deltaX = dx;
    var resistance = 0.35;
    var offset = -index * width() + deltaX;
    if ((index === 0 && deltaX > 0) || (index === slides.length - 1 && deltaX < 0)) {
      offset = -index * width() + deltaX * resistance;
    }
    setTransform(offset, false);
    if (Math.abs(deltaX) > 10) markInteracted();
  });

  viewport.addEventListener("pointerup", endDrag);
  viewport.addEventListener("pointercancel", endDrag);

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      markInteracted();
      goTo(index - 1, true);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      markInteracted();
      goTo(index + 1, true);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener("click", function () {
      var i = parseInt(dot.getAttribute("data-pdp-dot"), 10);
      if (isNaN(i)) return;
      markInteracted();
      goTo(i, true);
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var i = parseInt(thumb.getAttribute("data-pdp-thumb"), 10);
      if (isNaN(i)) return;
      markInteracted();
      goTo(i, true);
    });
  });

  root.addEventListener("keydown", function (event) {
    if (slides.length < 2) return;
    if (event.key === "ArrowRight") {
      event.preventDefault();
      markInteracted();
      goTo(index + 1, true);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      markInteracted();
      goTo(index - 1, true);
    } else if (event.key === "Home") {
      event.preventDefault();
      markInteracted();
      goTo(0, true);
    } else if (event.key === "End") {
      event.preventDefault();
      markInteracted();
      goTo(slides.length - 1, true);
    }
  });

  window.addEventListener("resize", onResize);
  goTo(0, false);
})();

(function () {
  var fig = document.querySelector("[data-pdp-story-alt]");
  if (!fig) return;
  var frames = Array.prototype.slice.call(fig.querySelectorAll(".pdp__story-visual__frame"));
  if (frames.length < 2) return;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;
  var index = 0;
  var intervalMs = 5200;
  setInterval(function () {
    frames[index].classList.remove("is-active");
    frames[index].hidden = true;
    index = (index + 1) % frames.length;
    frames[index].hidden = false;
    frames[index].classList.add("is-active");
  }, intervalMs);
})();

(function () {
  var buy = document.getElementById("sora-buy-now");
  var form = document.getElementById("sora-product-form");
  if (!buy || !form) return;
  buy.addEventListener("click", function () {
    var fd = new FormData(form);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: fd,
    }).then(function () {
      window.location.href = "/checkout";
    });
  });
})();
